var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-mask"},[_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"loading-image-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }